import { useFlags } from "launchdarkly-react-client-sdk";
import type { V2ResourceToPermission } from "src/components/permission/types-v2";
import type { ResourcePermissionInput } from "src/components/permission/use-resource-permission";

export const useViewAudienceInsightsPermissions = ({
  parentModelId,
  audienceId,
}: {
  parentModelId: string | number | undefined;
  audienceId: string | number | undefined;
}): ResourcePermissionInput<"model"> => {
  const { appAudienceInsightsOldPermissions } = useFlags();

  if (appAudienceInsightsOldPermissions) {
    return {
      v2: audienceId
        ? { resource: "model", id: audienceId.toString(), grant: "can_update" }
        : {
            resource: "model",
            grant: "can_create",
            creationOptions: {
              type: "audience",
              parentModelId: parentModelId?.toString() ?? "",
            },
          },
    };
  }

  return viewAudienceInsightsPermissions({ parentModelId, audienceId });
};

export const viewAudienceInsightsPermissions = ({
  parentModelId,
  audienceId,
}: {
  parentModelId: string | number | undefined;
  audienceId: string | number | undefined;
}): ResourcePermissionInput<"model"> => {
  return {
    v2: audienceId
      ? { resource: "model", id: audienceId.toString(), grant: "can_preview" }
      : {
          resource: "model",
          grant: "can_preview",
          creationOptions: {
            type: "audience",
            parentModelId: parentModelId?.toString() ?? "",
          },
        },
  };
};

export const viewChartDetailRoutePermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});

export const createChartPermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});

export const viewEditChartRoutePermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});

export const editChartPermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});

export const deleteChartPermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});

export const runChartPermission = (
  parentModelId: string | undefined,
): ResourcePermissionInput<V2ResourceToPermission> => ({
  v2: {
    resource: "model",
    grant: "can_preview",
    creationOptions: {
      type: "audience",
      parentModelId: parentModelId?.toString() ?? "",
    },
  },
});
